var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.forTasks ? 'base-button calendar-button' : 'base-button'},[_c('button',{class:_vm.classNames,on:{"click":function($event){return _vm.buttonClicked($event)}}},[(_vm.isLoading)?_c('i',{staticClass:"fa-spin fa-refresh fa"}):_vm._e(),_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c1cd874","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/buttons/BaseButton.vue
// module id = null
// module chunks = 